<template>
  <div>星络家居云物联科技有限公司创立于2019年9月24日，星络家居云物联科技有限公司宗旨，以认真，严谨，细心的工作态度，急客户所急，想客户所想为指导,主营：智能家居用品、安防、音响设备、照明器材、智能锁、监控设备、可视对讲设备、智能停车场设备、智能通道闸设备、智能车位引导设备的技术开发及销售;智能化系统研发、安装和销售;在网上从事商贸活动;电子商务平台的技术开发、维护;计算机软件技术的开发和销售;信息技术咨询、企业信息化咨询。公司位于风景秀丽的深圳市，欢迎各界朋友参观！</div>
</template>

<script>
export default {

}
</script>

<style scoped>
div{
  padding: 0 20px;
}
</style>
